module.exports = __webpack_public_path__ + "static/media/sensorpic2.a0be515a.jpg";